import { FolkLSPAttribute } from '../folk-lsp-attribute';
FolkLSPAttribute.define();
export { FolkLSPAttribute };
//# sourceMappingURL=folk-lsp-attribute.js.map